import { render, staticRenderFns } from "./DataloadInsemination.vue?vue&type=template&id=53b7fdbe&"
import script from "./DataloadInsemination.vue?vue&type=script&lang=js&"
export * from "./DataloadInsemination.vue?vue&type=script&lang=js&"
import style0 from "./DataloadInsemination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports